/**
 * Uses the above constants to convert back-end data into format front-end can use
 *
 * @method backToFront
 * @param {Object} backEndData Data to convert
 * @returns {Object} Converted data
 */
export function backToFront(backEndData) {
    let mappedHomePhone = null;
    let mappedCellPhone = null;
    let mappedWorkPhone = null;
    let mappedOkEmail = null;
    if (backEndData.canSendCollectionEmail) {
        mappedOkEmail = "yes";
    }
    else {
        mappedOkEmail = "no";
    }
    if (backEndData.homePhone) {
        mappedHomePhone = _prettyPhone(backEndData.homePhone);
    }
    if (backEndData.workPhone) {
        mappedWorkPhone = _prettyPhone(backEndData.workPhone);
    }
    if (backEndData.cellPhone) {
        mappedCellPhone = _prettyPhone(backEndData.cellPhone);
    }
    return {
        okEmail: mappedOkEmail,
        firstName: backEndData.firstName,
        lastName: backEndData.lastName,
        address: backEndData.address || "",
        address2: backEndData.address2,
        city: backEndData.city || "",
        state: backEndData.stateProvince || "",
        zip: backEndData.postalCode || "",
        phoneHome: mappedHomePhone,
        phoneCell: mappedCellPhone,
        phoneWork: mappedWorkPhone,
        phoneWorkExt: backEndData.workPhoneExtension,
        preferredPhone: backEndData.preferredPhone,
        email: backEndData.emailAddress,
        initialDeceased: backEndData.initialDeceased,
        bankAccounts: backEndData.bankAccounts,
        isComplete: backEndData.isComplete
    };
}
/**
 * Uses the constant to converts front-end data into format back-end can use
 *
 * @method frontToBack
 * @param {Object} frontEndData Data to convert
 * @returns {Object} Converted data
 */
export const frontToBack = (frontEndData) => {
    let mappedHomePhone = null;
    let mappedCellPhone = null;
    let mappedWorkPhone = null;
    let mappedOkEmail = null;
    if (frontEndData.okEmail === "yes") {
        mappedOkEmail = true;
    }
    else if (frontEndData.okEmail === "no") {
        mappedOkEmail = false;
    }
    if (frontEndData.phoneHome) {
        mappedHomePhone = _numbersOnly(frontEndData.phoneHome);
    }
    if (frontEndData.phoneWork) {
        mappedWorkPhone = _numbersOnly(frontEndData.phoneWork);
    }
    if (frontEndData.phoneCell) {
        mappedCellPhone = _numbersOnly(frontEndData.phoneCell);
    }
    return {
        canSendCollectionEmail: mappedOkEmail,
        firstName: frontEndData.firstName,
        lastName: frontEndData.lastName,
        address: frontEndData.address,
        address2: frontEndData.address2,
        city: frontEndData.city,
        stateProvince: frontEndData.state,
        postalCode: frontEndData.zip,
        homePhone: mappedHomePhone || "",
        cellPhone: mappedCellPhone || "",
        workPhone: mappedWorkPhone || "",
        workPhoneExtension: frontEndData.phoneWorkExt,
        preferredPhone: frontEndData.preferredPhone,
        emailAddress: frontEndData.email,
        initialDeceased: frontEndData.initialDeceased,
        bankAccounts: [],
        isComplete: frontEndData.isComplete,
        languagePreference: null
    };
};
/**
 * Removes characters that aren't numbers from a string
 *
 * @method _numbersOnly
 * @param {String} phone Phone number to strip
 * @return {String} numbersOnlyPhone Phone number with only numbers
 * @private
 */
export const _numbersOnly = (phone) => {
    const numbersOnlyPhone = phone.replace(/[^0-9]/g, "");
    return numbersOnlyPhone;
};
/**
 * Convert string of 10 digits to a formatted phone number
 *
 * @method _prettyPhone
 * @param {String} phone Phone number to strip
 * @return {String} prettyPhone Phone number with only numbers
 * @private
 */
export const _prettyPhone = (phone) => {
    if (phone == null) {
        return null;
    }
    const numbersOnlyPhone = _numbersOnly(phone);
    let prettyPhone;
    /* If the phone number from the API is 10 digits,
    format it in a nice way, otherwise use the numbe-only version. */
    if (numbersOnlyPhone.length === 10) {
        // tslint:disable-next-line:max-line-length
        prettyPhone = `${numbersOnlyPhone.substring(0, 3)}-${numbersOnlyPhone.substring(3, 6)}-${numbersOnlyPhone.substring(6, 10)}`;
    }
    else {
        prettyPhone = numbersOnlyPhone;
    }
    return prettyPhone;
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/profile/dataConversion.ts